import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useFilter } from '../Hooks';
import { dropdownContainer, css } from '../Utils';

export const Filter = ({ dataIndex }) => {
	const targetref = useRef(null);
	const dropref = useRef(null);
	const {
		filters,
		filterSearch,
		filterMultiple,
		filterState,
		setFilter,
	} = useFilter(dataIndex);
	const [filterCollection, setFilterCollection] = useState({});
	const [dropdown, setDropdown] = useState(false);

	React.useEffect(() => {
		const drop = dropref.current;
		const target = targetref.current;
		if (!(drop && target)) return;
		const { scrollTop, scrollLeft } = document.documentElement;
		const { top, left, height, width } = target.getBoundingClientRect();
		const y = scrollTop + top + height;
		const x = scrollLeft + left + width - drop.offsetWidth;
		css(drop, { left: `${x < 0 ? 15 : x}px`, top: `${y}px` });
	}, [dropref, targetref, dropdown]);

	let preventBlur = false;

	const handleFocus = () => setDropdown(true);
	const handlerBlur = () => {
		preventBlur || setDropdown(false);
		preventBlur = false;
	};
	const handleMouseUp = ({ target }) => {
		if (target.type === 'text') {
			target.focus();
		} else {
			targetref.current && targetref.current.focus();
		}
	};
	const handleMouseDown = (e) => {
		preventBlur = true;
	};
	const IOSFixedBug = (e) => {
		e.preventDefault();
		const target = e.target;
		if (target.matches('button')) target.focus();
		else target.closest('button').focus();
	};
	const hasFilterSearch = !!filterSearch;
	const { label: fslabel } = filterSearch || {};
	return (
		<>
			<button
				ref={targetref}
				className={`rt-filter${dropdown ? ' active' : ''}`}
				data-is-filtered={filterState.some(
					(each) => each.dataIndex === dataIndex
				)}
				onFocus={handleFocus}
				onBlur={handlerBlur}
				onTouchEnd={IOSFixedBug}
				title='filter'>
				<i className='rt-filter-icon' />
			</button>
			{dropdown &&
				ReactDOM.createPortal(
					<div
						ref={dropref}
						className='rt-filter-drop'
						onMouseDown={handleMouseDown}
						onMouseUp={handleMouseUp}>
						<form
							onSubmit={(e) => {
								e.preventDefault();
								targetref.current && targetref.current.blur();
								setDropdown(false);
								setFilter((prev) => {
									const update = prev.filter(
										(filter) => filter.dataIndex !== dataIndex
									);
									const value = hasFilterSearch
										? Object.keys(filterCollection).map((key) => {
												const collectionValue = filterCollection[key];
												return key === fslabel
													? filterSearch.like.replace(
															'{search}',
															collectionValue
													  )
													: collectionValue;
										  })
										: Object.values(filterCollection);
									return value.length
										? [
												...update,
												{
													dataIndex,
													value,
												},
										  ]
										: update;
								});
							}}>
							{hasFilterSearch && (
								<div className='rt-list'>
									<input
										data-filter-search={true}
										placeholder={fslabel}
										value={filterCollection[fslabel] || ''}
										onFocus={handleFocus}
										onBlur={handlerBlur}
										onChange={({ target }) =>
											setFilterCollection((prev) => {
												const update = { ...prev };
												const value = target.value;
												if (value) {
													update[fslabel] = value;
												} else {
													delete update[fslabel];
												}
												return update;
											})
										}
									/>
								</div>
							)}
							{filters &&
								filters.map(({ label, like, ...filter }) => (
									<label
										className='rt-list'
										key={label}
										onMouseUp={handleMouseDown}>
										<input
											className='rt-mr'
											{...filter}
											type={filterMultiple ? 'checkbox' : 'radio'}
											value={label}
											checked={!!filterCollection[label]}
											onClick={handleMouseUp}
											onChange={() =>
												setFilterCollection((prev) => {
													const update = filterMultiple ? { ...prev } : {};
													const isIn = label in update;
													if (isIn) {
														delete update[label];
													} else {
														update[label] = like;
													}
													return update;
												})
											}
										/>
										{label}
									</label>
								))}
							<div className='rt-filter-footer'>
								<button
									type='button'
									className='rt-btn rt-mr'
									onClick={() => {
										setFilterCollection({});
									}}>
									Reset
								</button>
								<button type='submit' className='rt-btn'>
									Ok
								</button>
							</div>
						</form>
					</div>,
					dropdownContainer
				)}
		</>
	);
};
